// Environment variables
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
const APP_NAME = process.env.REACT_APP_NAME || 'Industrial Paint System';
const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
const TOKEN_STORAGE_KEY = process.env.REACT_APP_TOKEN_STORAGE_KEY || 'auth_token';
const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'refresh_token';

// API endpoints
const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  USERS: '/users',
  CLIENTS: '/clients',
  PRODUCTS: '/products',
  PURCHASE_ORDERS: '/purchase-orders',
  WORK_ORDERS: '/work-orders',
  QUICKBOOKS: '/quickbooks',
};

// Pagination defaults
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

// Date format
const DATE_FORMAT = 'yyyy-MM-dd';
const DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';

// File upload limits
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

// Notification duration (in milliseconds)
const NOTIFICATION_DURATION = 5000;

// Refresh token interval (in milliseconds)
const REFRESH_TOKEN_INTERVAL = 15 * 60 * 1000; // 15 minutes

// Idle timeout (in milliseconds)
const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes

// WebSocket events
const WS_EVENTS = {
  PURCHASE_ORDER_UPDATED: 'purchase_order_updated',
  WORK_ORDER_UPDATED: 'work_order_updated',
};

const config = {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION,
  API_ENDPOINTS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_NUMBER,
  DATE_FORMAT,
  DATETIME_FORMAT,
  MAX_FILE_SIZE,
  ALLOWED_FILE_TYPES,
  NOTIFICATION_DURATION,
  TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_INTERVAL,
  IDLE_TIMEOUT,
  WS_EVENTS,
};

export default config;

// Also export individual constants for backwards compatibility
export {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION,
  API_ENDPOINTS,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_NUMBER,
  DATE_FORMAT,
  DATETIME_FORMAT,
  MAX_FILE_SIZE,
  ALLOWED_FILE_TYPES,
  NOTIFICATION_DURATION,
  TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_INTERVAL,
  IDLE_TIMEOUT,
  WS_EVENTS,
};